import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { IFacilityOverview, IStatusBarSegment } from './facility-overview-card.model';
import { SvgIconComponent } from '@ui-lib/components';
import { TranslateModule } from '@ngx-translate/core';
import {
  DEVICES_LIST_URL,
  getDevicesLinkQueryParams,
} from '../../../../../shared/utils/devices-link.function';

@Component({
  selector: 'mon-facility-overview-card',
  imports: [SvgIconComponent, TranslateModule, RouterLink],
  templateUrl: './facility-overview-card.component.html',
  styleUrl: './facility-overview-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacilityOverviewCardComponent {
  public readonly facility = input.required<IFacilityOverview>();

  /** Карточка открывает список аппаратов площадки. */
  public readonly canOpenDevices = input(false);

  protected readonly devicesListUrl = DEVICES_LIST_URL;

  protected readonly devicesQueryParams = computed(
    (): Params => getDevicesLinkQueryParams({ facilityIds: [this.facility().facilityId] }),
  );

  public static getPercent = (val: number, total: number): number => (val / total) * 100;

  public readonly segments = computed((): IStatusBarSegment[] => {
    const stats = this.facility();
    const total =
      stats.workingCount + stats.freeCount + stats.underRepairCount + stats.offlineCount;

    if (total === 0) return [];

    return [
      {
        type: 'working',
        width: FacilityOverviewCardComponent.getPercent(stats.workingCount, total),
      },
      { type: 'free', width: FacilityOverviewCardComponent.getPercent(stats.freeCount, total) },
      {
        type: 'repair',
        width: FacilityOverviewCardComponent.getPercent(stats.underRepairCount, total),
      },
      {
        type: 'offline',
        width: FacilityOverviewCardComponent.getPercent(stats.offlineCount, total),
      },
    ].filter((segment) => segment.width > 0);
  });
}
